import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "school-comp-table-body",
  templateUrl: "./school-comp-table-body.component.html",
  styleUrls: ["./school-comp-table-body.component.scss"],
})
export class SchoolCompTableBodyComponent implements OnInit {
  @Input() district;
  @Input() columns;
  @Input() schools;
  @Input() fixedColRowHoveredIndex;

  partialImagePath: string = "../../assets/images/";

  @Output() rowHoveredEvent = new EventEmitter<any>();

  constructor(private titleService: Title) {}

  ngOnInit() {}

  values(dict) {
    return Object.keys(dict).map(function (key) {
      return dict[key];
    });
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  rowHovered(index) {
    this.rowHoveredEvent.emit(index);
  }
}
